export default __webpack_public_path__ + "static/media/lab-time-icon.191deff2.svg";